/**
 * Entrega um arquivo gerado no navegador ou baixado da API para quem usa a
 * tela salvar, com o nome dado. O endereço temporário é liberado logo depois.
 */
export function salvarArquivo(arquivo: Blob, nomeDoArquivo: string): void {
  const endereco = URL.createObjectURL(arquivo);
  const ancora = document.createElement('a');
  ancora.href = endereco;
  ancora.download = nomeDoArquivo;
  ancora.click();
  URL.revokeObjectURL(endereco);
}
